import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import PlayIcon from '@material-ui/icons/PlayArrow';

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer'
  },
  background: {
    position: 'relative',
    height: '0',
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    paddingBottom: '56.25%'
  },
  icon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-12px',
    marginLeft: '-12px',
    color: 'rgba(255, 255, 255, 0.75)'
  },
  title: {
    color: '#ccc',
    marginBottom: theme.spacing(1)/2
  },
  paragraph: {
    color: '#ccc',
    fontSize: '0.8em',
    fontWeight: 300,
    margin: 0
  }
}));

export default (props) => {
  const vod = props.config;
  const classes = useStyles();
  return (
    <Grid container direction="row" spacing={3} className={classes.root} onClick={() => props.UpdateVideoSrc(vod)}>
      <Grid item xs={5}>
        <div className={classes.background} style={{backgroundImage: `url('${vod.videoPoster}')`}}>
          <div className={classes.icon}><PlayIcon className={classes.play} /></div>
        </div>
      </Grid>
      <Grid item xs={7}>
        <h4 className={classes.title}>{vod.videoTitle}</h4>
        <p className={classes.paragraph}>{vod.videoDescription}</p>
      </Grid>
    </Grid>
  );
};